import { PasswordResetService } from "./password.reset.service";

export class LoginExemptRoute {
    private static readonly paymentReturnRoutePattern = /\/payment\/(?:success|cancel)(?:\/|$|[?#])/i;

    public static isPaymentReturnRoute(href: string): boolean {
        return LoginExemptRoute.paymentReturnRoutePattern.test(href);
    }

    public static isLoginExemptRoute(href: string): boolean {
        return PasswordResetService.isPasswordResetRoute(href) || LoginExemptRoute.isPaymentReturnRoute(href);
    }
}
